import { render, staticRenderFns } from "./CheckboxFilter.vue?vue&type=template&id=473506a6&scoped=true"
import script from "./CheckboxFilter.vue?vue&type=script&lang=js"
export * from "./CheckboxFilter.vue?vue&type=script&lang=js"
import style0 from "./CheckboxFilter.vue?vue&type=style&index=0&id=473506a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473506a6",
  null
  
)

export default component.exports